/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultReferentialTagConversation } from '../../models/api-response-paged-result-referential-tag-conversation';
import { PagedRequestReferentialTagConversation } from '../../models/paged-request-referential-tag-conversation';

export interface SearchReferentialTagConversation$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestReferentialTagConversation
}

export function searchReferentialTagConversation(http: HttpClient, rootUrl: string, params: SearchReferentialTagConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultReferentialTagConversation>> {
  const rb = new RequestBuilder(rootUrl, searchReferentialTagConversation.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultReferentialTagConversation>;
    })
  );
}

searchReferentialTagConversation.PATH = '/v1/api/ui/referential/tag/search';
